<template>
  <Disclosure as="div" :class="navItem.externalWrapperClass" class="" v-slot="{ open }" :defaultOpen="new Boolean(navItem.current)">
    <DisclosureButton :class="[navItem.current ? 'bg-gray-100 text-gray-900' : 'text-gray-900 hover:bg-gray-50', navItem.notDisplay ? 'sr-only' : '', 'group w-full flex items-center pr-1 py-2 text-left text-sm font-semibold rounded-md focus:outline-none']">
      <span class="flex-1 uppercase">
        {{ navItem.name }}
      </span>

      <span v-if="navItem.count" :class="[navItem.current ? 'bg-white' : 'bg-gray-600 group-hover:bg-gray-200', 'ml-3 inline-block py-0.5 px-3 text-xs font-medium rounded-full']">
        {{ navItem.count }}
      </span>

      <component v-if="navItem.section == 'static'" :is="navItem.icon" class="mr-2 flex-shrink-0 h-5 w-5 text-gray-600" aria-hidden="true" />
      <svg v-else :class="[open ? 'rotate-90' : '', 'text-gray-600 flex-shrink-0 h-4 w-4 transform transition-colors ease-in-out duration-150']" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
      </svg>
    </DisclosureButton>
<!--    <DisclosurePanel class="space-y-1">-->
    <DisclosurePanel :static="navItem.section === 'static' ? new Boolean(true): null">
      <template v-for="subItem in navItem.children" :key="subItem.name">
        <action-button-nav v-if="subItem.type === 'button'" :nav-item="subItem" @click="subItem.onClickCallback(this)"></action-button-nav>
        <item-nav v-else-if="!subItem.children && !subItem.actions" :nav-item="subItem"></item-nav>
        <complex-item-nav v-else-if="subItem.children || subItem.actions" :nav-item="subItem"></complex-item-nav>
        <DisclosureButton v-else
                          :key="subItem.name"
                          as="a"
                          :href="subItem.href"
                          class="group w-full flex items-center pl-5 pr-2 py-2 text-base font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50">
          {{ subItem.name }}
        </DisclosureButton>
      </template>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/vue'
import ActionButtonNav from "@/components/Navigation/ActionButtonNav";
import ItemNav from "@/components/Navigation/ItemNav";
import ComplexItemNav from "@/components/Navigation/ComplexItemNav";
export default {
  name: "SectionNav",
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    ComplexItemNav,
    ItemNav,
    ActionButtonNav,
  },
  props: ["navItem"],
}
</script>